<template>
  <div class="rfirfa">
    <div class="rfirfa_container">
      <div class="rfirfa_one">
        <rfi @showDetail="showDetail"></rfi>
      </div>
      <div class="rfirfa_one">
        <rfa @showDetail="showDetail"></rfa>
      </div>
    </div>
  </div>
</template>

<script>

import rfi from "@/components/rfirfa/rfi";
import rfa from "@/components/rfirfa/rfa";
import axios from 'axios'

export default {
  name: "rfirfa_manage",
  props: ['project_id'],
  data() {
    return {
      showtable: true,
      rfflag: 0,
      descipline: 0,
      status: 0
    }
  },
  methods: {
    detailClose() {
      console.log("clicked!")
      this.showtable = false
    },
    showDetail(rfflag, descipline, status) {
      console.log("in showDetail")
      console.log(rfflag + '|' + descipline + '|' + status)
      this.showtable = true
      this.rfflag = rfflag
      this.descipline = descipline
      this.status = status
      let postData = {
        project_id: this.project_id,
        type: '1',
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token')
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjStaff", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        this.myChart.hideLoading()
        if (errNo == "0") {
          this.dataNotNull = true
          var result = resp.data.result;
          var data = this.analysisResult(result);
          this.myChart.setOption({
            legend: {
              data: data.legends,
              itemGap: 24,
            },
            series: [{
              data: data.staffs
            }]
          })
        } else {
          this.dataNotNull = false
        }
      }).catch(error => {
        alert(error)
        this.myChart.hideLoading()
        this.dataNotNull = false
      })
    },
  },
  components: {rfi, rfa},
  mounted() {
  }
}
</script>

<style lang="stylus" scoped>
.rfirfa {
  width 100%
  height 100%
  background-image url("../../assets/img/sm_backgroud.jpg")
  background-size 100% 100%
  background-repeat no-repeat

}

.rfirfa_container {
  width 100%
  height 100%
  background-color #0D0E1380
  //background-color rgba(13,14,19,0.7)
  display flex
  justify-content space-around
  align-items center
}

.rfirfa_one {
  width 40%
  height 90%
  border 1px solid #EEEEEE
  background-color #0D0E1380
  //background-color rgba(13,14,19,0.7)
}

.rfirfa_detail {
  position: absolute;
  top 2.5%
  left 2.5%
  width 95%
  height 95%
  z-index 99
}

.close_img {
  position: absolute;
  background-image: url("../../assets/close.png");
  background-repeat: no-repeat;
  right: 10px;
  top: 10px;
  width: 20px;
  height: 20px;
  z-index 999
}
</style>



// WEBPACK FOOTER //
// src/components/rfirfa/main.vue